export const translations = {
  en: {
    nav: {
      whatLearn: "What kids learn",
      ages: "Ages 10–16",
      courses: "Courses",
      login: "Login",
      signup: "Get started",
    },
    hero: {
      badge: "AI literacy for kids · GCC",
      title1: "Where kids learn AI",
      title2: "by playing",
      subtitle:
        "Sparkl turns curiosity into confidence. Ages 10–16 build, play, and question AI — guided by Sparky, our friendly robot.",
      ctaDemo: "Try a demo lesson",
      ctaStart: "Get started free",
      statAges: "Ages 10–16",
      statIdeas: "5 Big Ideas",
      statSafety: "Safety-first",
    },
    how: {
      title: "How Sparkl works",
      subtitle: "Three simple loops kids actually enjoy.",
      s1t: "Discover",
      s1d: "Bite-sized stories reveal what AI is — and what it isn't.",
      s2t: "Play & Build",
      s2d: "Kids train models, remix prompts, and ship tiny AI projects.",
      s3t: "Ask Sparky",
      s3d: "A friendly tutor that answers questions the safe way.",
    },
    ideas: {
      title: "Five Big Ideas of AI",
      subtitle: "The mental model every kid deserves before their first algorithm.",
      i1t: "AI senses",
      i1d: "Machines see, hear, and read the world through data.",
      i2t: "AI thinks in steps",
      i2d: "Every model follows a recipe — a step-by-step plan.",
      i3t: "AI learns from examples",
      i3d: "Show it a thousand cats, it starts to spot cats.",
      i4t: "AI talks",
      i4d: "Language models turn words into predictions and back.",
      i5t: "AI changes our world",
      i5d: "How we use it shapes what it becomes.",
    },
    gcc: {
      tagline: "Rooted in ‘ilm · علم",
      body:
        "Sparkl is built for GCC families — Arabic-first when you need it, and always grounded in ‘ilm, the pursuit of knowledge.",
    },
    ages: {
      title: "Three age bands, one journey",
      f1t: "Foundation",
      f1a: "Ages 10–12",
      f1d: "Curiosity, patterns, and first prompts. No jargon.",
      f2t: "Builder",
      f2a: "Ages 13–14",
      f2d: "Train tiny models. Remix real datasets. Ship projects.",
      f3t: "Innovator",
      f3a: "Ages 15–16",
      f3d: "Build with LLMs, evaluate outputs, debate ethics.",
    },
    safety: {
      title: "Sparkl's AI Rulebook",
      subtitle: "Simple rules that keep learning fun and safe.",
      doTitle: "Do",
      dontTitle: "Don't",
      do: [
        "Ask questions — even the silly ones.",
        "Check facts with a human you trust.",
        "Give credit when AI helps you.",
        "Take breaks. Play offline too.",
      ],
      dont: [
        "Share private info with any AI.",
        "Treat AI answers as always true.",
        "Use AI to be unkind to anyone.",
        "Pretend AI-made work is 100% yours.",
      ],
    },
    footer: {
      brand: "Sparkl",
      tagline: "AI literacy for the next generation.",
      credit: "A product by ITHR Technologies.",
      rights: "All rights reserved.",
    },
    auth: {
      loginTitle: "Welcome back",
      loginSub: "Log in to keep building with Sparky.",
      signupTitle: "Create your Sparkl account",
      signupSub: "It takes 30 seconds. No credit card.",
      email: "Email",
      password: "Password",
      name: "Your name",
      submitLogin: "Log in",
      submitSignup: "Create account",
      google: "Continue with Google",
      or: "or",
      haveAccount: "Already have an account?",
      noAccount: "New to Sparkl?",
      goLogin: "Log in",
      goSignup: "Sign up",
    },
    dashboard: {
      welcome: "Welcome",
      body: "Continue where you left off — or browse the catalog for something new.",
      logout: "Log out",
      role: "Role",
      myCourses: "My courses",
      myOrders: "My orders",
      noOrders: "No unlock orders yet.",
      browseAll: "Browse all courses",
      continue: "Continue",
      noEnrollments: "You haven't enrolled in a course yet. Pick one from the catalog to get started.",
    },
    courses: {
      title: "Course catalog",
      subtitle: "Forty-five courses across three age bands. Start free, grow when you're ready.",
      tabFoundation: "Foundation · 10–12",
      tabBuilder: "Builder · 13–14",
      tabInnovator: "Innovator · 15–16",
      allBands: "All bands",
      searchPlaceholder: "Search courses…",
      cardModules: "modules",
      cardFreePreview: "5 free modules",
      cardEnroll: "Enroll",
      cardOpen: "Open",
      cardEnrolled: "Enrolled",
      difficulty: "Difficulty",
      empty: "No courses match your filters yet.",
      comingSoonBadge: "Coming soon",
      comingSoonTitleFoundation: "Foundation courses launching soon",
      comingSoonTitleBuilder: "Builder courses launching soon",
      comingSoonTitleInnovator: "Innovator courses launching soon",
      comingSoonBody: "More Sparkl courses are being crafted right now — bilingual EN + AR, kid-safe, playful. Check back very soon!",
    },
    courseDetail: {
      whatYoullLearn: "What you'll learn",
      moduleList: "Modules",
      free: "Free",
      paid: "Paid",
      exam: "Final exam",
      locked: "Locked",
      unlockSoon: "Unlock coming soon",
      unlockThis: "Unlock",
      unlockAll: "Unlock all paid modules",
      unlocked: "Unlocked",
      examLocked: "Available after modules 1–19",
      enrollCta: "Enroll — free preview",
      openCta: "Continue learning",
      alreadyEnrolled: "You're enrolled",
      progress: "progress",
      startCta: "Start module 1",
    },
    unlock: {
      title: "Unlock this lesson",
      titleFull: "Unlock the full course",
      subtitleSingle: "You'll get instant access to this module.",
      subtitleFull: "You'll get instant access to every paid module in this course.",
      included: "What's included",
      demoBanner: "Secure payment powered by Stripe. Your card details never touch our servers.",
      confirm: "Pay with card",
      cancel: "Cancel",
      processing: "Redirecting to Stripe…",
      successToast: "Unlocked ✨",
      errorAlreadyUnlocked: "Already unlocked.",
      errorExamNotPurchasable: "The final exam is unlocked by completing modules 1–19.",
      errorGeneric: "Something went wrong. Try again.",
      errorPaymentTemporarilyUnavailable: "Payments are temporarily unavailable. Our team has been notified — please try again in a few minutes.",
      errorPaymentBusy: "Payments are busy right now — please try again in a moment.",
      errorPaymentGeneric: "Payment provider returned an error. Please try again shortly.",
      openModule: "Open module",
      backToCourse: "Back to course",
      orderId: "Order",
      status_pending: "Pending",
      status_succeeded: "Unlocked",
      status_failed: "Failed",
      status_cancelled: "Cancelled",
      savings: "Bundle saves you",
      checkoutSuccessTitle: "Payment successful!",
      checkoutSuccessBody: "Your modules are being unlocked…",
      checkoutSuccessDone: "Ready! Continue learning.",
      checkoutCancelTitle: "Payment cancelled",
      checkoutCancelBody: "No charge was made. You can try again whenever you're ready.",
      checkoutCheckAgain: "Check payment status",
      checkoutTakeMeBack: "Back to my course",
    },
    exam: {
      title: "Final exam",
      subtitle: "Auto-graded, unlimited retakes. Pass with 70% to earn your certificate.",
      startCta: "Start exam",
      resumeCta: "Resume exam",
      prereqTitle: "Almost there!",
      prereqBody: "Complete these modules first to unlock the exam:",
      questions: "questions",
      threshold: "Pass threshold",
      question: "Question",
      of: "of",
      next: "Next",
      prev: "Previous",
      submitCta: "Submit exam",
      submitConfirmTitle: "Ready to submit?",
      submitConfirmBody: "You can retake the exam if you don't pass — but this attempt will be locked in.",
      submitConfirmYes: "Submit",
      submitConfirmNo: "Keep answering",
      passed: "You passed! 🎉",
      failed: "Not this time — try again",
      score: "Score",
      review: "Review",
      correct: "Correct",
      incorrect: "Not quite",
      explanation: "Why",
      retakeCta: "Retake exam",
      downloadCert: "Download certificate",
      shareVerify: "Share verifiable link",
      copiedToast: "Link copied ✓",
      backToCourse: "Back to course",
    },
    verify: {
      title: "Certificate verification",
      valid: "Valid certificate ✅",
      invalid: "Certificate not found",
      studentName: "Student",
      course: "Course",
      score: "Score",
      issued: "Issued",
      certId: "Certificate ID",
      poweredBy: "Verified by Sparkl LMS",
    },
    certs: {
      title: "Certificates",
      empty: "Certificates you earn will appear here.",
      download: "Download PDF",
      verify: "Verify",
    },
    moduleViewer: {
      moduleLabel: "Module",
      of: "of",
      activity: "Activity",
      askSparky: "Ask Sparky",
      askSparkyAbout: "Ask Sparky about this",
      askSparkyFree: "Ask Sparky anything",
      sparkyComingSoon: "Sparky is warming up — this live tutor arrives in Phase 3.",
      complete: "Mark complete",
      completed: "Completed",
      nextModule: "Next module",
      prevModule: "Previous",
      backToCourse: "Back to course",
      lockedTitle: "This module is locked",
      lockedPaid: "This is a paid module. Unlock the full course in the upcoming Sparkl Family plan.",
      lockedExam: "The final exam opens after modules 1–19. Keep going!",
      lockedEnroll: "Enroll in this course to unlock the free modules.",
      lockedCtaCourse: "Back to course",
      completeToast: "You unlocked {done} of {total} modules! ⭐",
    },
    sparky: {
      title: "Chat with Sparky",
      subtitle: "Your friendly AI buddy for this lesson.",
      inputPlaceholder: "Ask Sparky anything about this lesson…",
      send: "Send",
      newChat: "New chat",
      close: "Close",
      typing: "Sparky is thinking…",
      warming: "Sparky is warming up — try again soon.",
      streamError: "Sparky lost the signal. Give it another go.",
      rateLimited: "Whoa, so many questions! Try again in a little bit.",
      convFull: "This chat is full — start a new chat with Sparky.",
      emptyHint: "Tap a suggested question below or type your own.",
      unauthorized: "You need access to this lesson to chat with Sparky.",
    },
    admin: {
      nav: "Admin",
      title: "Content authoring",
      courses: "Courses",
      modules: "Modules",
      questions: "Exam questions",
      newCourse: "New course",
      newModule: "New module",
      newQuestion: "New question",
      publish: "Publish",
      unpublish: "Unpublish",
      draft: "Draft",
      published: "Published",
      delete: "Delete",
      confirmDelete: "Delete this? It cannot be undone.",
      titleEn: "Title (English)",
      titleAr: "Title (Arabic)",
      descEn: "Description (English)",
      descAr: "Description (Arabic)",
      summaryEn: "Summary (English)",
      summaryAr: "Summary (Arabic)",
      promptEn: "Question prompt (English)",
      promptAr: "Question prompt (Arabic)",
      explanationEn: "Explanation (English)",
      explanationAr: "Explanation (Arabic)",
      band: "Age band",
      bigIdea: "Big idea",
      difficulty: "Difficulty (1-5)",
      order: "Order",
      type: "Type",
      minutes: "Estimated minutes",
      choiceLetter: "Letter",
      choiceEn: "Text (English)",
      choiceAr: "Text (Arabic)",
      correctChoice: "Correct choice",
      save: "Save",
      cancel: "Cancel",
      created: "Created ✓",
      updated: "Saved ✓",
      backToCourses: "← Back to courses",
      editModules: "Edit modules",
      editQuestions: "Edit questions",
    },
    superadmin: {
      nav: "Super Admin",
      title: "Platform control room",
      overview: "Overview",
      users: "Users",
      enrollments: "Enrollments",
      orders: "Orders",
      certificates: "Certificates",
      logins: "Login activity",
      sparky: "Sparky",
      exams: "Exams",
      content: "Content seed",
      exports: "Exports",
      totalUsers: "Total users",
      new30d: "New (30d)",
      active30d: "Active (30d)",
      byLanguage: "By language",
      byRole: "By role",
      topCourses: "Top courses",
      revenueMock: "Revenue",
      revenue: "Revenue",
      totalOrders: "Total orders",
      totalRevenue: "Total revenue",
      totalCerts: "Certificates issued",
      passRate: "Exam pass rate",
      globalReach: "Global reach",
      globalReachDesc: "{countries} countries · {cities} cities · {logins} logins (last 30d)",
      searchUsers: "Search email or name…",
      role: "Role",
      language: "Language",
      banned: "Banned",
      lastLogin: "Last login",
      createdAt: "Created",
      actions: "Actions",
      impersonate: "Impersonate",
      makeAdmin: "Make admin",
      makeStudent: "Make student",
      ban: "Ban",
      unban: "Unban",
      deleteUser: "Delete user",
      confirmBan: "Ban this user? Their sessions will be revoked.",
      confirmUnban: "Unban this user?",
      confirmDeleteUser: "Delete this user and all their data? This cannot be undone.",
      confirmImpersonate: "Impersonate this user? Your super-admin session will be restored on end.",
      recentLogins: "Recent logins",
      timestamp: "Time",
      email: "Email",
      method: "Method",
      ip: "IP",
      country: "Country",
      city: "City",
      device: "Device",
      status: "Status",
      success: "Success",
      failure: "Failure",
      filterRange: "Range",
      filterCountry: "Country",
      filterMethod: "Method",
      filterSuccess: "Success",
      all: "All",
      last7d: "Last 7 days",
      last30d: "Last 30 days",
      last90d: "Last 90 days",
      allTime: "All time",
      loginsByCountry: "Logins by country",
      topCities: "Top cities",
      unique: "unique users",
      pending: "Pending",
      succeeded: "Succeeded",
      cancelled: "Cancelled",
      exportUsers: "Export users",
      exportOrders: "Export orders",
      exportCerts: "Export certificates",
      exportEnrollments: "Export enrollments",
      exportLogins: "Export login events",
      revoke: "Revoke",
      reissue: "Reissue",
      confirmRevoke: "Revoke this certificate? It will be marked invalid.",
      forceUnlockAll: "Force unlock all paid modules",
      returnToSuperAdmin: "← Return to super admin",
      impersonationBanner: "Impersonating {name} · session ends in {mins} min",
      empty: "No records yet.",
      loading: "Loading…",
    },
    lang: { toggle: "العربية" },
  },
  ar: {
    nav: {
      whatLearn: "ماذا يتعلم الأطفال",
      ages: "١٠–١٦ سنة",
      courses: "الدورات",
      login: "تسجيل الدخول",
      signup: "ابدأ الآن",
    },
    hero: {
      badge: "تعليم الذكاء الاصطناعي للأطفال · دول الخليج",
      title1: "حيث يتعلم الأطفال الذكاء الاصطناعي",
      title2: "باللعب",
      subtitle:
        "سباركل يحوّل الفضول إلى ثقة. أطفال من ١٠ إلى ١٦ سنة يبنون، يلعبون، ويسألون عن الذكاء الاصطناعي — بإرشاد سباركي، الروبوت الودود.",
      ctaDemo: "جرّب درساً تجريبياً",
      ctaStart: "ابدأ مجاناً",
      statAges: "١٠–١٦ سنة",
      statIdeas: "٥ أفكار كبرى",
      statSafety: "الأمان أولاً",
    },
    how: {
      title: "كيف يعمل سباركل",
      subtitle: "ثلاث خطوات بسيطة يحبها الأطفال فعلاً.",
      s1t: "اكتشف",
      s1d: "قصص قصيرة تكشف ما هو الذكاء الاصطناعي — وما ليس كذلك.",
      s2t: "العب وابنِ",
      s2d: "يدرّب الأطفال نماذج، يعدّلون التعليمات، وينفّذون مشاريع صغيرة.",
      s3t: "اسأل سباركي",
      s3d: "مُعلّم ودود يجيب على الأسئلة بطريقة آمنة.",
    },
    ideas: {
      title: "الأفكار الخمس الكبرى للذكاء الاصطناعي",
      subtitle: "النموذج الذهني الذي يستحقه كل طفل قبل أول خوارزمية.",
      i1t: "الذكاء الاصطناعي يستشعر",
      i1d: "تشاهد الآلات وتسمع وتقرأ العالم عبر البيانات.",
      i2t: "يفكّر بخطوات",
      i2d: "كل نموذج يتبع وصفة — خطة خطوة بخطوة.",
      i3t: "يتعلّم من الأمثلة",
      i3d: "أره ألف صورة قط، وسيبدأ بتمييز القطط.",
      i4t: "يتحدث",
      i4d: "نماذج اللغة تحوّل الكلمات إلى تنبؤات ثم عكسياً.",
      i5t: "يغيّر عالمنا",
      i5d: "طريقة استخدامنا له تُشكّل ما سيصبح عليه.",
    },
    gcc: {
      tagline: "متجذّر في ‘ilm · علم",
      body:
        "سباركل مبني لعائلات الخليج — عربي أولاً عندما تحتاجه، ومتجذّر دائماً في العلم، السعي وراء المعرفة.",
    },
    ages: {
      title: "ثلاث مراحل عمرية، رحلة واحدة",
      f1t: "الأساس",
      f1a: "١٠–١٢ سنة",
      f1d: "فضول، أنماط، وأوّل تعليمات. بلا مصطلحات معقّدة.",
      f2t: "الباني",
      f2a: "١٣–١٤ سنة",
      f2d: "تدريب نماذج صغيرة. تعديل بيانات حقيقية. إنجاز مشاريع.",
      f3t: "المبتكر",
      f3a: "١٥–١٦ سنة",
      f3d: "بناء بنماذج لغوية، تقييم النتائج، ومناقشة الأخلاقيات.",
    },
    safety: {
      title: "قواعد سباركل للذكاء الاصطناعي",
      subtitle: "قواعد بسيطة تحافظ على المتعة والأمان.",
      doTitle: "افعل",
      dontTitle: "لا تفعل",
      do: [
        "اسأل — حتى الأسئلة السخيفة.",
        "تحقّق من الحقائق مع شخص تثق به.",
        "اعترف بمساهمة الذكاء الاصطناعي.",
        "خذ استراحات. العب خارج الشاشة أيضاً.",
      ],
      dont: [
        "لا تشارك معلومات خاصة مع أي ذكاء اصطناعي.",
        "لا تعتبر إجاباته صحيحة دائماً.",
        "لا تستخدمه لإيذاء أحد.",
        "لا تدّعِ أن عمل الذكاء الاصطناعي عملك كاملاً.",
      ],
    },
    footer: {
      brand: "سباركل",
      tagline: "تعليم الذكاء الاصطناعي للجيل القادم.",
      credit: "منتج من شركة إثر للتقنية.",
      rights: "جميع الحقوق محفوظة.",
    },
    auth: {
      loginTitle: "مرحباً بعودتك",
      loginSub: "سجّل الدخول لمواصلة البناء مع سباركي.",
      signupTitle: "أنشئ حسابك في سباركل",
      signupSub: "يستغرق ٣٠ ثانية. بدون بطاقة ائتمان.",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      name: "اسمك",
      submitLogin: "تسجيل الدخول",
      submitSignup: "إنشاء حساب",
      google: "المتابعة مع Google",
      or: "أو",
      haveAccount: "لديك حساب بالفعل؟",
      noAccount: "جديد على سباركل؟",
      goLogin: "تسجيل الدخول",
      goSignup: "إنشاء حساب",
    },
    dashboard: {
      welcome: "أهلاً",
      body: "تابع من حيث توقفت — أو تصفّح الفهرس لتكتشف جديداً.",
      logout: "تسجيل الخروج",
      role: "الدور",
      myCourses: "دوراتي",
      myOrders: "طلباتي",
      noOrders: "لا توجد طلبات فتح بعد.",
      browseAll: "تصفّح جميع الدورات",
      continue: "تابع",
      noEnrollments: "لم تسجّل في أي دورة بعد. اختر واحدة من الفهرس للبدء.",
    },
    courses: {
      title: "فهرس الدورات",
      subtitle: "خمس وأربعون دورة على ثلاث مراحل عمرية. ابدأ مجاناً وتقدّم حين تشاء.",
      tabFoundation: "الأساس · ١٠–١٢",
      tabBuilder: "الباني · ١٣–١٤",
      tabInnovator: "المبتكر · ١٥–١٦",
      allBands: "جميع المراحل",
      searchPlaceholder: "ابحث عن دورة…",
      cardModules: "وحدة",
      cardFreePreview: "٥ وحدات مجانية",
      cardEnroll: "سجّل",
      cardOpen: "افتح",
      cardEnrolled: "مسجَّل",
      difficulty: "الصعوبة",
      empty: "لا توجد دورات تطابق البحث بعد.",
      comingSoonBadge: "قريباً",
      comingSoonTitleFoundation: "دورات مرحلة الأساس قريباً",
      comingSoonTitleBuilder: "دورات مرحلة الباني قريباً",
      comingSoonTitleInnovator: "دورات مرحلة المبتكر قريباً",
      comingSoonBody: "نُعدّ لك المزيد من دورات سباركل الآن — ثنائية اللغة إنجليزي وعربي، آمنة للأطفال، ومرحة. عُد قريباً!",
    },
    courseDetail: {
      whatYoullLearn: "ماذا ستتعلّم",
      moduleList: "الوحدات",
      free: "مجاني",
      paid: "مدفوع",
      exam: "الامتحان النهائي",
      locked: "مقفل",
      unlockSoon: "الفتح قريباً",
      unlockThis: "افتح",
      unlockAll: "افتح جميع الوحدات المدفوعة",
      unlocked: "مفتوح",
      examLocked: "يفتح بعد الوحدات ١-١٩",
      enrollCta: "سجّل — معاينة مجانية",
      openCta: "تابع التعلّم",
      alreadyEnrolled: "أنت مسجَّل",
      progress: "التقدّم",
      startCta: "ابدأ الوحدة ١",
    },
    unlock: {
      title: "افتح هذا الدرس",
      titleFull: "افتح الدورة كاملة",
      subtitleSingle: "ستحصل على وصول فوري لهذه الوحدة.",
      subtitleFull: "ستحصل على وصول فوري لجميع الوحدات المدفوعة في هذه الدورة.",
      included: "ما المشمول",
      demoBanner: "دفع آمن عبر Stripe. تفاصيل بطاقتك لا تمر عبر خوادمنا أبداً.",
      confirm: "ادفع بالبطاقة",
      cancel: "إلغاء",
      processing: "جارٍ التحويل إلى Stripe…",
      successToast: "تم الفتح ✨",
      errorAlreadyUnlocked: "مفتوح مسبقاً.",
      errorExamNotPurchasable: "الامتحان النهائي يُفتح بإكمال الوحدات ١-١٩.",
      errorGeneric: "حدث خطأ ما. حاول مرة أخرى.",
      errorPaymentTemporarilyUnavailable: "الدفع غير متاح مؤقتاً. تم إعلام فريقنا — يرجى المحاولة بعد بضع دقائق.",
      errorPaymentBusy: "الدفع مشغول الآن — يرجى المحاولة بعد لحظات.",
      errorPaymentGeneric: "أعاد مزوّد الدفع خطأً. يرجى المحاولة بعد قليل.",
      openModule: "افتح الوحدة",
      backToCourse: "العودة إلى الدورة",
      orderId: "الطلب",
      status_pending: "قيد الانتظار",
      status_succeeded: "مفتوح",
      status_failed: "فشل",
      status_cancelled: "ملغى",
      savings: "الباقة توفّر لك",
      checkoutSuccessTitle: "تم الدفع بنجاح!",
      checkoutSuccessBody: "جارٍ فتح وحداتك…",
      checkoutSuccessDone: "جاهز! تابع التعلّم.",
      checkoutCancelTitle: "تم إلغاء الدفع",
      checkoutCancelBody: "لم يُخصم أي مبلغ. يمكنك المحاولة مجدداً في أي وقت.",
      checkoutCheckAgain: "تحقّق من حالة الدفع",
      checkoutTakeMeBack: "العودة إلى دورتي",
    },
    exam: {
      title: "الامتحان النهائي",
      subtitle: "تصحيح آلي، إعادة غير محدودة. اجتز بنسبة ٧٠٪ للحصول على الشهادة.",
      startCta: "ابدأ الامتحان",
      resumeCta: "تابع الامتحان",
      prereqTitle: "على وشك الوصول!",
      prereqBody: "أكمل هذه الوحدات أولاً لفتح الامتحان:",
      questions: "أسئلة",
      threshold: "حدّ النجاح",
      question: "سؤال",
      of: "من",
      next: "التالي",
      prev: "السابق",
      submitCta: "سلّم الامتحان",
      submitConfirmTitle: "جاهز للتسليم؟",
      submitConfirmBody: "يمكنك إعادة الامتحان إذا لم تنجح — لكن هذه المحاولة ستُحفظ.",
      submitConfirmYes: "سلّم",
      submitConfirmNo: "تابع الإجابة",
      passed: "نجحت! 🎉",
      failed: "ليس هذه المرة — حاول مجدّداً",
      score: "النتيجة",
      review: "المراجعة",
      correct: "صحيح",
      incorrect: "ليس بالضبط",
      explanation: "لماذا",
      retakeCta: "أعد الامتحان",
      downloadCert: "حمّل الشهادة",
      shareVerify: "شارك رابط التحقّق",
      copiedToast: "تم نسخ الرابط ✓",
      backToCourse: "العودة إلى الدورة",
    },
    verify: {
      title: "التحقّق من الشهادة",
      valid: "شهادة صحيحة ✅",
      invalid: "الشهادة غير موجودة",
      studentName: "الطالب",
      course: "الدورة",
      score: "النتيجة",
      issued: "تاريخ الإصدار",
      certId: "رقم الشهادة",
      poweredBy: "تحقّقت بواسطة سباركل",
    },
    certs: {
      title: "الشهادات",
      empty: "ستظهر شهاداتك هنا عند اكتسابها.",
      download: "حمّل PDF",
      verify: "تحقّق",
    },
    moduleViewer: {
      moduleLabel: "الوحدة",
      of: "من",
      activity: "نشاط",
      askSparky: "اسأل سباركي",
      askSparkyAbout: "اسأل سباركي عن هذا",
      askSparkyFree: "اسأل سباركي أي شيء",
      sparkyComingSoon: "سباركي يستعد — المعلّم المباشر يصل في المرحلة الثالثة.",
      complete: "أكمل الوحدة",
      completed: "مُكتملة",
      nextModule: "الوحدة التالية",
      prevModule: "السابقة",
      backToCourse: "عد إلى الدورة",
      lockedTitle: "هذه الوحدة مقفلة",
      lockedPaid: "هذه وحدة مدفوعة. افتح الدورة كاملة في خطة العائلة القادمة.",
      lockedExam: "الامتحان النهائي يفتح بعد الوحدات ١–١٩. تابع التقدم!",
      lockedEnroll: "سجّل في هذه الدورة لفتح الوحدات المجانية.",
      lockedCtaCourse: "العودة إلى الدورة",
      completeToast: "لقد فتحت {done} من {total} وحدة! ⭐",
    },
    sparky: {
      title: "الدردشة مع سباركي",
      subtitle: "صديقك الذكي في هذا الدرس.",
      inputPlaceholder: "اسأل سباركي أي شيء عن الدرس…",
      send: "إرسال",
      newChat: "دردشة جديدة",
      close: "إغلاق",
      typing: "سباركي يفكّر…",
      warming: "سباركي يستعد — حاول بعد قليل.",
      streamError: "فقد سباركي الإشارة. حاول مرة أخرى.",
      rateLimited: "يا لكثرة الأسئلة! انتظر قليلاً ثم عاود.",
      convFull: "امتلأت هذه الدردشة — ابدأ دردشة جديدة مع سباركي.",
      emptyHint: "اضغط سؤالاً مقترحاً أو اكتب سؤالك.",
      unauthorized: "تحتاج إلى الوصول لهذا الدرس للدردشة مع سباركي.",
    },
    admin: {
      nav: "الإدارة",
      title: "تأليف المحتوى",
      courses: "الدورات",
      modules: "الوحدات",
      questions: "أسئلة الامتحان",
      newCourse: "دورة جديدة",
      newModule: "وحدة جديدة",
      newQuestion: "سؤال جديد",
      publish: "نشر",
      unpublish: "إلغاء النشر",
      draft: "مسوّدة",
      published: "منشور",
      delete: "حذف",
      confirmDelete: "هل تريد الحذف؟ لا يمكن التراجع.",
      titleEn: "العنوان (إنجليزي)",
      titleAr: "العنوان (عربي)",
      descEn: "الوصف (إنجليزي)",
      descAr: "الوصف (عربي)",
      summaryEn: "الملخص (إنجليزي)",
      summaryAr: "الملخص (عربي)",
      promptEn: "نص السؤال (إنجليزي)",
      promptAr: "نص السؤال (عربي)",
      explanationEn: "الشرح (إنجليزي)",
      explanationAr: "الشرح (عربي)",
      band: "المرحلة العمرية",
      bigIdea: "الفكرة الكبرى",
      difficulty: "الصعوبة (١-٥)",
      order: "الترتيب",
      type: "النوع",
      minutes: "المدة التقديرية (دقائق)",
      choiceLetter: "الحرف",
      choiceEn: "النص (إنجليزي)",
      choiceAr: "النص (عربي)",
      correctChoice: "الاختيار الصحيح",
      save: "حفظ",
      cancel: "إلغاء",
      created: "تم الإنشاء ✓",
      updated: "تم الحفظ ✓",
      backToCourses: "→ العودة إلى الدورات",
      editModules: "تعديل الوحدات",
      editQuestions: "تعديل الأسئلة",
    },
    superadmin: {
      nav: "المدير الأعلى",
      title: "غرفة التحكم بالمنصة",
      overview: "نظرة عامة",
      users: "المستخدمون",
      enrollments: "التسجيلات",
      orders: "الطلبات",
      certificates: "الشهادات",
      logins: "نشاط الدخول",
      sparky: "سباركي",
      exams: "الامتحانات",
      content: "بذر المحتوى",
      exports: "التصدير",
      totalUsers: "إجمالي المستخدمين",
      new30d: "جدد (٣٠ يوم)",
      active30d: "نشطون (٣٠ يوم)",
      byLanguage: "حسب اللغة",
      byRole: "حسب الدور",
      topCourses: "أفضل الدورات",
      revenueMock: "الإيرادات",
      revenue: "الإيرادات",
      totalOrders: "إجمالي الطلبات",
      totalRevenue: "إجمالي الإيرادات",
      totalCerts: "الشهادات المُصدَرة",
      passRate: "نسبة النجاح",
      globalReach: "الانتشار العالمي",
      globalReachDesc: "{countries} دولة · {cities} مدينة · {logins} دخول (آخر ٣٠ يوم)",
      searchUsers: "ابحث بالبريد أو الاسم…",
      role: "الدور",
      language: "اللغة",
      banned: "محظور",
      lastLogin: "آخر دخول",
      createdAt: "تاريخ الإنشاء",
      actions: "إجراءات",
      impersonate: "انتحال",
      makeAdmin: "جعل مشرف",
      makeStudent: "جعل طالب",
      ban: "حظر",
      unban: "رفع الحظر",
      deleteUser: "حذف المستخدم",
      confirmBan: "حظر هذا المستخدم؟ سيتم إنهاء جلساته.",
      confirmUnban: "رفع الحظر عن هذا المستخدم؟",
      confirmDeleteUser: "حذف هذا المستخدم وكل بياناته؟ لا يمكن التراجع.",
      confirmImpersonate: "انتحال هذا المستخدم؟ ستُستعاد جلستك عند الإنهاء.",
      recentLogins: "الدخولات الأخيرة",
      timestamp: "الوقت",
      email: "البريد",
      method: "الطريقة",
      ip: "الآيبي",
      country: "الدولة",
      city: "المدينة",
      device: "الجهاز",
      status: "الحالة",
      success: "نجاح",
      failure: "فشل",
      filterRange: "الفترة",
      filterCountry: "الدولة",
      filterMethod: "الطريقة",
      filterSuccess: "الحالة",
      all: "الكل",
      last7d: "آخر ٧ أيام",
      last30d: "آخر ٣٠ يوم",
      last90d: "آخر ٩٠ يوم",
      allTime: "كل الأوقات",
      loginsByCountry: "الدخول حسب الدولة",
      topCities: "أفضل المدن",
      unique: "مستخدم فريد",
      pending: "قيد الانتظار",
      succeeded: "ناجح",
      cancelled: "ملغى",
      exportUsers: "تصدير المستخدمين",
      exportOrders: "تصدير الطلبات",
      exportCerts: "تصدير الشهادات",
      exportEnrollments: "تصدير التسجيلات",
      exportLogins: "تصدير سجل الدخول",
      revoke: "إلغاء",
      reissue: "إعادة إصدار",
      confirmRevoke: "إلغاء هذه الشهادة؟ ستصبح غير صالحة.",
      forceUnlockAll: "فتح كل الوحدات المدفوعة",
      returnToSuperAdmin: "→ العودة إلى المدير الأعلى",
      impersonationBanner: "تنتحل شخصية {name} · تنتهي الجلسة خلال {mins} دقيقة",
      empty: "لا توجد سجلات بعد.",
      loading: "جارٍ التحميل…",
    },
    lang: { toggle: "English" },
  },
};
